import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import testimonial from './testimonial.json';

function Testimonial() {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                },
            },
        ],
    };

    return (
        <div className="tst-wrapper">
            {/* Section header */}
            <div className="tst-header">
                <span className="tp-section-sub-title">
                    {/* <span className="tst-badge-dot"></span> */}
                    TESTIMONIAL
                </span>
                <h2 className="tst-heading">
                   Hear from our<br />Happy customers
                </h2>
            </div>

            {/* Slider */}
            <Slider ref={sliderRef} {...settings}>
                {testimonial.map((item, index) => (
                    <div key={index} className="tst-slide-wrap">
                        <div className="tst-card">
                            {/* Top row: quote + stars */}
                            <div className="tst-card__top">
                                <span className="tst-quote">&#10077;</span>
                                <div className="tst-stars">
                                    {[1,2,3,4,5].map(i => (
                                        <span key={i}>&#9733;</span>
                                    ))}
                                </div>
                            </div>

                            {/* Review text */}
                            <p className="tst-card__text">{item.description}</p>

                            {/* Divider */}
                            <hr className="tst-card__divider" />

                            {/* Author */}
                            <div className="tst-card__author">
                                <img
                                    src={item.logo}
                                    alt={item.name}
                                    className="tst-card__avatar"
                                />
                                <div className="tst-card__author-info">
                                    <h5 className="tst-card__name">{item.name}</h5>
                                    <span className="tst-card__role">{item.designation}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

            {/* Custom PREVIEWS / NEXT navigation */}
            <div className="tst-nav-row">
                <button
                    className="tst-nav-btn"
                    onClick={() => sliderRef.current.slickPrev()}
                    aria-label="Previous"
                >
                    PREVIEWS
                </button>
                <div className="tst-nav-line"></div>
                <button
                    className="tst-nav-btn"
                    onClick={() => sliderRef.current.slickNext()}
                    aria-label="Next"
                >
                    NEXT
                </button>
            </div>
        </div>
    );
}

export default Testimonial;
